import type { InputSelectProps } from '../../types'
import { labelVariants } from './label.styles'

export const InputSelectLabel = ({
  children,
  size = 'md',
  disabled,
  readonly,
}: {
  children: string
  size?: InputSelectProps['size']
  disabled?: boolean
  readonly?: boolean
}) => {
  return (
    <label
      className={labelVariants({ size, disabled, readonly })}
      style={
        // @TODO - Exchange for a semantic token
        {
          '--line-height-none': '0%',
        } as Record<string, string>
      }
    >
      {children}
    </label>
  )
}
